import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    body {
      margin: 0;
      padding: 0;
      position: relative;
      font-family: kanit_regular;
      font-size: 14px;
      color: #333333;
    }
     button {
      border: none; 
      &:focus {
        outline: none;
      }
    }
    input {
      &:focus {
        outline: none;
      }
    }
    textarea {
      &:focus {
        outline: none;
      }
    }
  }
`;
